(function () {
  'use strict';
  function sections(scope) {
    var result = Array.prototype.slice.call(scope.querySelectorAll('[data-kg-six-reviews]'));
    if (scope.matches && scope.matches('[data-kg-six-reviews]')) result.unshift(scope);
    return result;
  }
  function initialize(scope, reload) {
    sections(scope).forEach(function (section) {
      if (reload) section.kgSixReviewsCleanup?.();
      if (section.dataset.kgSixReviewsReady === 'true') return;
      section.dataset.kgSixReviewsReady = 'true';
      var controller = new AbortController();
      var tabs = Array.prototype.slice.call(section.querySelectorAll('[data-kg-six-review-tab]'));
      var panels = Array.prototype.slice.call(section.querySelectorAll('[data-kg-six-review-panel]'));
      section.kgSixReviewsCleanup = function () {
        controller.abort();
        section.querySelectorAll('video').forEach(function (video) { video.pause(); });
        delete section.dataset.kgSixReviewsReady;
      };
      function select(tab, focus) {
        var value = tab.dataset.kgSixReviewTab;
        tabs.forEach(function (candidate) {
          var active = candidate === tab;
          candidate.setAttribute('aria-selected', String(active));
          candidate.tabIndex = active ? 0 : -1;
        });
        panels.forEach(function (panel) {
          var hidden = panel.dataset.kgSixReviewPanel !== value;
          if (hidden) panel.querySelectorAll('video').forEach(function (video) { video.pause(); });
          panel.hidden = hidden;
        });
        if (focus) tab.focus();
      }
      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () { select(tab, false); }, { signal: controller.signal });
        tab.addEventListener('keydown', function (event) {
          var next = index;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          else if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = tabs.length - 1;
          else return;
          event.preventDefault();
          select(tabs[next], true);
        }, { signal: controller.signal });
      });
      var initial = tabs.find(function (tab) { return tab.getAttribute('aria-selected') === 'true'; }) || tabs[0];
      if (initial) select(initial, false);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialize(document); }, { once: true });
  } else initialize(document);
  if (!window.kindgutSixReviewsSectionListeners) {
    window.kindgutSixReviewsSectionListeners = true;
    document.addEventListener('shopify:section:load', function (event) { initialize(event.target, true); });
    document.addEventListener('shopify:section:unload', function (event) {
      sections(event.target).forEach(function (section) { section.kgSixReviewsCleanup?.(); });
    });
  }
})();
